<!-- Divider -->
<div class="zop-vertical-navigation-item-wrapper divider" [ngClass]="item.classes?.wrapper"></div>